<template>
  <a-drawer
    :maskClosable="false"
    width="680"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="
      onCloseConfirm(() => {
        open = false
      })
    "
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />

    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="优惠券标题" prop="couponName" :required="true">
        <a-input v-model="form.couponName" placeholder="请输入" :maxLength="20" />
      </a-form-model-item>

      <a-form-model-item label="副标题" prop="subTitle" :required="true">
        <a-input v-model="form.subTitle" placeholder="请输入" :maxLength="32" />
      </a-form-model-item>

      <a-form-model-item label="模块类型" prop="whType" :required="true">
        <a-select v-model="form.whType" placeholder="请选择" @change="onWhTypeChange" :disabled="!!form.id">
          <a-select-option :value="10">商城</a-select-option>
          <a-select-option :value="20">维修</a-select-option>
          <a-select-option :value="30">全景套餐</a-select-option>
        </a-select>
        <div v-if="!!form.id" style="color: #999; font-size: 12px; margin-top: 4px">编辑时模块类型不可修改</div>
      </a-form-model-item>

      <a-form-model-item label="标题图" prop="fileUrl" >
        <div :class="{ 'upload-disabled': !!form.id }">
          <file-upload
            ref="uploader"
            type="image"
            :defaultList="Array.isArray(form.fileUrl) ? form.fileUrl : [form.fileUrl].filter(Boolean)"
            :count="1"
            :autoCropWidth="300"
            :autoCropHeight="120"
            :beforeUploadExtra="limitImage"
            @input="getImg($event, 'fileUrl')"
            :disabled="!!form.id"
          />
        </div>
        <div v-if="!!form.id" style="color: #999; font-size: 12px; margin-top: 4px;">
          编辑时标题图不可修改
        </div>
      </a-form-model-item>

      <a-form-model-item label="优惠券类型" prop="couponType" :required="true">
        <a-radio-group v-model="form.couponType" @change="onTypeChange">
          <a-radio :value="10">代金券</a-radio>
          <a-radio :value="20">折扣券</a-radio>
          <a-radio :value="30">免单券</a-radio>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item v-if="form.couponType === 10" label="减免金额" prop="reduceAmount" :required="true">
        <a-input-number
          :min="0.01"
          :precision="2"
          :step="0.01"
          v-model="form.reduceAmount"
          placeholder="请输入"
          style="width: 100%"
        />
      </a-form-model-item>

      <a-form-model-item v-if="form.couponType === 20" label="折扣额度" prop="couponDiscount" :required="true">
        <a-input-number
          :min="0.01"
          :max="1"
          :precision="2"
          :step="0.01"
          v-model="form.couponDiscount"
          placeholder="例：0.90 表示 9 折"
          style="width: 100%"
        />
      </a-form-model-item>

      <a-form-model-item label="使用门槛" prop="cashCondition" :required="true">
        <a-input-number
          :min="0"
          :precision="2"
          :step="0.01"
          v-model="form.cashCondition"
          placeholder="满多少元可用，0 表示无门槛"
          style="width: 100%"
        />
      </a-form-model-item>

      <a-form-model-item label="生效方式" prop="validTimeType" :required="true">
        <a-radio-group v-model="form.validTimeType" @change="onValidTypeChange" :disabled="!!form.id">
          <a-radio :value="1">固定时间</a-radio>
          <a-radio :value="2">领券后生效</a-radio>
        </a-radio-group>
        <div v-if="!!form.id" style="color: #999; font-size: 12px; margin-top: 4px">编辑时生效方式不可修改</div>
      </a-form-model-item>

      <a-form-model-item v-if="form.validTimeType === 1" label="固定时段" prop="dateRange" :required="true">
        <a-range-picker
          style="width: 100%"
          show-time
          format="YYYY-MM-DD HH:mm:ss"
          v-model="form.dateRange"
          @change="onDateRangeChange"
          :disabled="!!form.id"
        />
        <div v-if="!!form.id" style="color: #999; font-size: 12px; margin-top: 4px">编辑时固定时段不可修改</div>
      </a-form-model-item>

      <a-form-model-item
        v-if="form.validTimeType === 2"
        label="领券后X天起生效"
        prop="afterReceiveDays"
        :required="true"
      >
        <a-input-number
          :min="0"
          :precision="0"
          v-model="form.afterReceiveDays"
          placeholder="领取后 N 天起生效，0表示立即生效"
          style="width: 100%"
          :disabled="!!form.id"
        />
        <div v-if="!!form.id" style="color: #999; font-size: 12px; margin-top: 4px">编辑时生效天数不可修改</div>
      </a-form-model-item>

      <a-form-model-item v-if="form.validTimeType === 2" label="有效天数" prop="validDays" :required="true">
        <a-input-number
          :min="1"
          :precision="0"
          v-model="form.validDays"
          placeholder="有效天数"
          style="width: 100%"
          :disabled="!!form.id"
        />
        <div v-if="!!form.id" style="color: #999; font-size: 12px; margin-top: 4px">编辑时有效天数不可修改</div>
      </a-form-model-item>

      <a-form-model-item label="领取方式" prop="getWay" :required="true">
        <a-select v-model="form.getWay" placeholder="请选择" @change="onGetWayChange" :disabled="!!form.id">
          <a-select-option :value="0">客户领取</a-select-option>
          <a-select-option :value="10">平台发放</a-select-option>
          <a-select-option :value="20">激活码领取</a-select-option>
          <a-select-option :value="30">二维码扫码</a-select-option>
          <a-select-option :value="40">核销优惠券</a-select-option>
        </a-select>
        <div v-if="!!form.id" style="color: #999; font-size: 12px; margin-top: 4px">编辑时领取方式不可修改</div>
      </a-form-model-item>

      <a-form-model-item v-if="form.getWay === 0" label="库存设置" prop="unlimitedStock" :required="true">
        <a-radio-group v-model="form.unlimitedStock" @change="onUnlimitedStockChange" :disabled="!!form.id">
          <a-radio :value="true">无限库存</a-radio>
          <a-radio :value="false">限制库存</a-radio>
        </a-radio-group>
        <div v-if="!!form.id" style="color: #999; font-size: 12px; margin-top: 4px">编辑时库存设置不可修改</div>
      </a-form-model-item>

      <a-form-model-item
        v-if="form.getWay === 0 && !form.unlimitedStock"
        label="总库存"
        prop="sourceStock"
        :required="true"
      >
        <a-input-number
          :min="1"
          :precision="0"
          v-model="form.sourceStock"
          placeholder="请输入库存数量"
          style="width: 100%"
          :disabled="!!form.id"
        />
        <div v-if="!!form.id" style="color: #999; font-size: 12px; margin-top: 4px">编辑时总库存不可修改</div>
      </a-form-model-item>

      <a-form-model-item v-if="form.getWay === 0" label="每人限领" prop="limitNum" :required="true">
        <a-input-number
          :min="1"
          :precision="0"
          v-model="form.limitNum"
          placeholder="不填默认为 1"
          style="width: 100%"
          :disabled="!!form.id"
        />
        <div v-if="!!form.id" style="color: #999; font-size: 12px; margin-top: 4px">编辑时每人限领不可修改</div>
      </a-form-model-item>

      <a-form-model-item v-if="form.getWay === 0" label="领取间隔" prop="limitCycle" :required="true">
        <a-select v-model="form.limitCycle" placeholder="请选择领取间隔" :disabled="!!form.id">
          <a-select-option :value="0">无限制</a-select-option>
          <a-select-option :value="-1">每周一次</a-select-option>
          <a-select-option :value="-2">每月一次</a-select-option>
          <a-select-option v-for="n in 30" :key="n" :value="n">{{ n }}天</a-select-option>
        </a-select>
        <div v-if="!!form.id" style="color: #999; font-size: 12px; margin-top: 4px">编辑时领取间隔不可修改</div>
      </a-form-model-item>

      <a-form-model-item label="适用商品" prop="suitableProdType" :required="true">
        <a-radio-group v-model="form.suitableProdType" @change="onSuitableProdTypeChange">
          <a-radio :value="0">全部商品参与</a-radio>
          <a-radio :value="10">指定商品参与</a-radio>
          <a-radio :value="20">指定商品不参与</a-radio>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item
        v-if="form.suitableProdType === 10 || form.suitableProdType === 20"
        :label="modalTitle"
        prop="comboIds"
        :required="true"
      >
        <a-button @click="handleOpenSelectModal">
          {{ getSelectButtonText() }}
        </a-button>
        <div v-if="selectedProdRows.length" style="margin-top: 8px">
          <a-tag v-for="p in selectedProdRows" :key="p.id" closable @close="removeProd(p)">
            {{ getProdDisplayName(p) }}
          </a-tag>
        </div>
      </a-form-model-item>

      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" placeholder="请输入" :rows="3" :maxLength="200" />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>

    <component
      :is="currentModalComponent"
      v-if="modalVisible && currentModalComponent"
      :visible.sync="modalVisible"
      v-model="selectedProdRows"
      :cate-list="cateList"
      @ok="onProdSelected"
    />
  </a-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import { getObj, addObj, putObj } from '@/api/coupon/controller'
import ProductSelectModal from './ProductSelectModal.vue'
import MaintenanceSelectModal from './MaintenanceSelectModal.vue'
import PanoramaPackageSelectModal from './PanoramaPackageSelectModal.vue'

export default {
  name: 'CouponCreateForm',
  props: {
    statusOptions: { type: Array, required: true },
    userList: { type: Array, required: true },
  },
  components: {
    ProductSelectModal,
    MaintenanceSelectModal,
    PanoramaPackageSelectModal,
  },

  data() {
    return {
      modalVisible: false,
      selectedProdRows: [],
      open: false,
      showLoading: false,
      submitLoading: false,
      cateList: [],
      formTitle: '',
      form: this.initForm(),
      // 默认图片
      defaultImage: 'http://hoy-test-1308702491.cos.ap-beijing.myqcloud.com/hoy/oth/IMG_20251121_211227__342045.png',
      rules: {
        couponName: [
          { required: true, message: '请输入优惠券标题' },
          { max: 20, message: '标题不能超过20个字符' },
        ],
        subTitle: [
          { required: true, message: '请输入副标题' },
          { max: 32, message: '副标题不能超过32个字符' },
        ],
        whType: [{ required: true, message: '请选择模块类型' }],
        fileUrl: [], // 标题图改为非必填
        couponType: [{ required: true, message: '请选择优惠券类型' }],
        reduceAmount: [
          {
            validator: (rule, value, callback) => {
              if (this.form.couponType === 10 && (!value || value <= 0)) {
                callback(new Error('请输入减免金额'))
              } else {
                callback()
              }
            },
          },
        ],
        couponDiscount: [
          {
            validator: (rule, value, callback) => {
              if (this.form.couponType === 20 && (!value || value <= 0)) {
                callback(new Error('请输入折扣额度'))
              } else {
                callback()
              }
            },
          },
        ],
        cashCondition: [{ required: true, message: '请输入使用门槛' }],
        validTimeType: [{ required: true, message: '请选择生效方式' }],
        dateRange: [
          {
            required: true,
            message: '请选择有效期',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (this.form.validTimeType === 1 && (!value || value.length !== 2)) {
                callback(new Error('请选择固定时段'))
              } else {
                callback()
              }
            },
          },
        ],
        afterReceiveDays: [
          {
            validator: (rule, value, callback) => {
              if (this.form.validTimeType === 2 && (value === undefined || value === null || value < 0)) {
                callback(new Error('请输入领取后生效天数'))
              } else {
                callback()
              }
            },
          },
        ],
        validDays: [
          {
            validator: (rule, value, callback) => {
              if (this.form.validTimeType === 2 && (!value || value <= 0)) {
                callback(new Error('请输入有效天数'))
              } else {
                callback()
              }
            },
          },
        ],
        getWay: [{ required: true, message: '请选择领取方式' }],
        unlimitedStock: [
          {
            validator: (rule, value, callback) => {
              if (this.form.getWay === 0 && value === undefined) {
                callback(new Error('请选择库存设置方式'))
              } else {
                callback()
              }
            },
          },
        ],
        sourceStock: [
          {
            validator: (rule, value, callback) => {
              if (this.form.getWay === 0 && !this.form.unlimitedStock && (!value || value <= 0)) {
                callback(new Error('请输入总库存数量'))
              } else {
                callback()
              }
            },
          },
        ],
        limitNum: [
          {
            validator: (rule, value, callback) => {
              if (this.form.getWay === 0 && (!value || value <= 0)) {
                callback(new Error('请输入每人限领数量'))
              } else {
                callback()
              }
            },
          },
        ],
        limitCycle: [
          {
            validator: (rule, value, callback) => {
              if (this.form.getWay === 0 && value === undefined) {
                callback(new Error('请选择领取间隔'))
              } else {
                callback()
              }
            },
          },
        ],
        suitableProdType: [{ required: true, message: '请选择适用商品类型' }],
        comboIds: [
          {
            validator: (rule, value, callback) => {
              if (
                (this.form.suitableProdType === 10 || this.form.suitableProdType === 20) &&
                (!value || value.length === 0)
              ) {
                callback(new Error('请选择商品'))
              } else {
                callback()
              }
            },
          },
        ],
      },
    }
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),

    currentModalComponent() {
      const componentMap = {
        0: 'ProductSelectModal',
        10: 'ProductSelectModal',
        20: 'ProductSelectModal',
        30: 'PanoramaPackageSelectModal',
      }
      return componentMap[this.form.whType] || 'ProductSelectModal'
    },

    modalTitle() {
      const titleMap = {
        0: '选择通用商品',
        10: '选择商城商品',
        20: '选择维修分类',
        30: '选择全景套餐',
      }
      return titleMap[this.form.whType] || '选择商品'
    },
  },
  mounted() {
    this.setImageAccept()
  },
  methods: {
    onGetWayChange() {
      if (this.form.getWay !== 0) {
        this.form.unlimitedStock = true
        this.form.sourceStock = 0
        this.form.limitNum = 0
        this.form.limitCycle = 0
      } else {
        this.form.unlimitedStock = false
        this.form.sourceStock = 1
        this.form.limitNum = 1
        this.form.limitCycle = 0
      }

      this.$nextTick(() => {
        this.$refs.form.clearValidate(['unlimitedStock', 'sourceStock', 'limitNum', 'limitCycle'])
      })
    },

    onUnlimitedStockChange() {
      if (this.form.unlimitedStock) {
        this.form.sourceStock = 0
        this.$nextTick(() => {
          this.$refs.form.clearValidate('sourceStock')
        })
      } else {
        this.form.sourceStock = 1
      }
    },

    getSelectButtonText() {
      return `${this.modalTitle}（已选 ${this.selectedProdRows.length} 项）`
    },

    getProdDisplayName(prod) {
      if (this.form.whType === 20) {
        return prod.categoryName || prod.prodName || '维修分类'
      } else if (this.form.whType === 30) {
        return prod.packageName || '全景套餐'
      } else {
        return prod.prodName || '商品'
      }
    },

    handleOpenSelectModal() {
      this.modalVisible = true
    },

    onWhTypeChange() {
      this.modalVisible = false
      this.selectedProdRows = []
      this.form.comboIds = []
    },

    setImageAccept() {
      this.$nextTick(() => {
        const cmp = this.$refs.uploader
        if (!cmp) {
          setTimeout(() => this.setImageAccept(), 50)
          return
        }
        const input =
          cmp.$el.querySelector('input[type=file]') || cmp.$el.parentElement.querySelector('input[type=file]')
        if (input) {
          input.setAttribute('accept', 'image/jpg,image/jpeg,image/png,image/gif,image/webp')
        } else {
          setTimeout(() => this.setImageAccept(), 50)
        }
      })
    },
    limitImage(file) {
      // 编辑时禁止上传图片
      if (this.form.id) {
        this.$message.error('编辑时标题图不可修改')
        return false
      }

      const allow = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp']
      const ok = allow.includes(file.type)
      if (!ok) this.$message.error('只能上传图片')
      return ok
    },

    removeProd(row) {
      const idx = this.selectedProdRows.findIndex((r) => r.id === row.id)
      if (idx > -1) this.selectedProdRows.splice(idx, 1)
      this.form.comboIds = this.selectedProdRows.map((r) => r.id)
      // 移除商品后，重新验证该字段
      this.$nextTick(() => {
        this.$refs.form.validateField('comboIds')
      })
    },
    onProdSelected(rows) {
      this.form.comboIds = rows.map((r) => r.id)
      this.selectedProdRows = rows
      // 选择完商品后，清除该字段的校验错误
      this.$nextTick(() => {
        this.$refs.form.clearValidate('comboIds')
      })
    },

    onSuitableProdTypeChange() {
      this.selectedProdRows = []
      this.form.comboIds = []
    },
    initForm() {
      return {
        id: undefined,
        couponName: '',
        subTitle: '',
        whType: 10,
        fileUrl: this.defaultImage, // 设置默认图片
        couponType: 10,
        reduceAmount: undefined,
        couponDiscount: undefined,
        cashCondition: 0,
        validTimeType: 1,
        startTime: undefined,
        endTime: undefined,
        afterReceiveDays: 0,
        validDays: undefined,
        getWay: 0,
        unlimitedStock: false,
        sourceStock: 1,
        limitNum: 1,
        limitCycle: 0,
        suitableProdType: 0,
        comboIds: [],
        remark: '',
        dateRange: [],
      }
    },
    getImg(url, field) {
      // 编辑时禁止修改图片
      if (this.form.id) {
        this.$message.error('编辑时标题图不可修改')
        return
      }
      // 如果上传的是默认图片，保持默认图片路径
      if (url === this.defaultImage) {
        this.form[field] = this.defaultImage
      } else {
        this.form[field] = url
      }
      this.$refs.form.clearValidate(field)
    },
    onTypeChange() {
      if (this.form.couponType !== 10) this.form.reduceAmount = undefined
      if (this.form.couponType !== 20) this.form.couponDiscount = undefined
      this.$nextTick(() => {
        this.$refs.form.validateField('reduceAmount')
        this.$refs.form.validateField('couponDiscount')
      })
    },
    onValidTypeChange() {
      this.form.dateRange = []
      this.form.startTime = undefined
      this.form.endTime = undefined
      this.form.afterReceiveDays = 0
      this.form.validDays = undefined
      this.$nextTick(() => {
        this.$refs.form.clearValidate('dateRange')
        this.$refs.form.clearValidate('afterReceiveDays')
        this.$refs.form.clearValidate('validDays')
      })
    },
    onDateRangeChange(momentArr) {
      this.form.dateRange = momentArr
      this.form.startTime = momentArr?.[0]?.format('YYYY-MM-DD HH:mm:ss') || undefined
      this.form.endTime = momentArr?.[1]?.format('YYYY-MM-DD HH:mm:ss') || undefined

      this.$nextTick(() => {
        this.$refs.form.validateField('dateRange')
      })
    },
    cancel() {
      this.onCloseConfirm(() => {
        this.open = false
      })
    },
    reset() {
      this.form = this.initForm()
      this.selectedProdRows = []
      this.modalVisible = false
      // 确保重置时显示默认图片
      this.$nextTick(() => {
        if (this.$refs.uploader) {
          // 直接设置imageUrl，但需要处理完整URL的情况
          if (this.defaultImage.startsWith('http')) {
            // 对于完整HTTP URL，直接设置
            this.$refs.uploader.imageUrl = this.defaultImage
          } else {
            // 对于相对路径，让组件自己处理
            this.$refs.uploader.imageUrl = this.defaultImage
          }
        }
      })
    },
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '新增优惠券'
      // 确保新增时显示默认图片
      this.$nextTick(() => {
        if (this.$refs.uploader) {
          // 直接设置imageUrl，但需要处理完整URL的情况
          if (this.defaultImage.startsWith('http')) {
            // 对于完整HTTP URL，直接设置
            this.$refs.uploader.imageUrl = this.defaultImage
          } else {
            // 对于相对路径，让组件自己处理
            this.$refs.uploader.imageUrl = this.defaultImage
          }
        }
      })
    },
    handleUpdate(row, ids) {
      this.reset()
      const id = row ? row.id : ids
      getObj(id).then(({ data }) => {
        let selectedProdRows = []

        if (data.comboIds && data.comboIds.length > 0) {
          if (data.whType === 20) {
            selectedProdRows = data.comboIds.map((id) => ({ id, categoryName: `维修分类${id}` }))
          } else if (data.whType === 30) {
            selectedProdRows = data.comboIds.map((id) => ({ id, packageName: `全景套餐${id}` }))
          } else {
            selectedProdRows = data.comboIds.map((id) => ({ id, prodName: `商品${id}` }))
          }
        }

        const unlimitedStock = data.sourceStock === 0

        this.form = {
          ...data,
          unlimitedStock,
          sourceStock: unlimitedStock ? 0 : data.sourceStock,
          fileUrl: (data.fileUrl && data.fileUrl.trim() !== '') ? data.fileUrl : this.defaultImage, // 如果没有图片URL或为空字符串，使用默认图片
          dateRange:
            data.validTimeType === 1 && data.startTime && data.endTime
              ? [moment(data.startTime), moment(data.endTime)]
              : [],
        }
        this.selectedProdRows = selectedProdRows
        this.open = true
        this.formTitle = '修改优惠券'

        // 确保编辑时正确显示图片
        this.$nextTick(() => {
          if (this.$refs.uploader) {
            const displayUrl = this.form.fileUrl || this.defaultImage
            if (displayUrl.startsWith('http')) {
              this.$refs.uploader.imageUrl = displayUrl
            } else {
              this.$refs.uploader.imageUrl = displayUrl
            }
          }
        })
      })
    },

    buildSubmitData() {
      const formData = { ...this.form }

      delete formData.dateRange
      delete formData.unlimitedStock

      // 处理默认图片：如果是默认图片，提交空字符串让后端处理
      if (formData.fileUrl === this.defaultImage) {
        formData.fileUrl = ''
      }

      // 根据接口文档，只提交编辑接口支持的字段
      if (this.form.id) {
        // 编辑时只保留接口支持的字段
        const editData = {
          id: formData.id,
          cashCondition: formData.cashCondition,
          comboIds: formData.comboIds || [],
          couponDiscount: formData.couponDiscount,
          couponName: formData.couponName,
          couponType: formData.couponType,
          fileUrl: formData.fileUrl,
          reduceAmount: formData.reduceAmount,
          remark: formData.remark,
          subTitle: formData.subTitle,
          suitableProdType: formData.suitableProdType,
        }

        // 根据优惠券类型删除不需要的字段
        if (editData.couponType !== 10) {
          delete editData.reduceAmount
        }
        if (editData.couponType !== 20) {
          delete editData.couponDiscount
        }

        // 如果是全部商品参与，删除comboIds
        if (editData.suitableProdType === 0) {
          delete editData.comboIds
        }

        return editData
      }

      // 新增时保持原有逻辑
      if (formData.getWay !== 0) {
        formData.sourceStock = 0
        formData.limitNum = 0
        formData.limitCycle = 0
      }

      if (formData.couponType !== 10) {
        delete formData.reduceAmount
      }
      if (formData.couponType !== 20) {
        delete formData.couponDiscount
      }

      if (formData.suitableProdType === 0) {
        delete formData.comboIds
      }

      if (formData.validTimeType === 1) {
        delete formData.afterReceiveDays
        delete formData.validDays
      } else {
        delete formData.startTime
        delete formData.endTime
      }

      return formData
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          const errorFields = Object.keys(this.$refs.form.fields)
          const firstErrorField = errorFields.find((field) => this.$refs.form.fields[field].validateState === 'error')
          if (firstErrorField) {
            const element = document.querySelector(`[data-vv-name="${firstErrorField}"]`)
            if (element) element.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
          return
        }

        this.submitLoading = true
        const submitData = this.buildSubmitData()

        const api = this.form.id ? putObj : addObj
        api(submitData)
          .then(() => {
            this.$message.success(this.form.id ? '修改成功' : '新增成功')
            this.open = false
            this.$emit('ok')
          })
          .catch((error) => {
            console.error('提交失败:', error)
            this.$message.error('提交失败，请重试')
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    },

    onCloseConfirm(callback) {
      // 检查是否有修改过的内容（排除默认图片）
      const hasChanges =
        this.form.couponName || this.form.subTitle || (this.form.fileUrl && this.form.fileUrl !== this.defaultImage)

      if (hasChanges) {
        this.$confirm({
          title: '确认关闭',
          content: '表单数据尚未保存，确定要关闭吗？',
          onOk: callback,
          onCancel: () => {},
        })
      } else {
        callback()
      }
    },
  },
}
</script>

<style scoped>
:deep(.ant-form-item-required::before) {
  display: inline-block;
  margin-right: 4px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
}

.upload-disabled {
  position: relative;
}

.upload-disabled::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.5);
  cursor: not-allowed;
  z-index: 10;
}

.upload-disabled :deep(.ant-upload),
.upload-disabled :deep(.ant-btn) {
  pointer-events: none;
  opacity: 0.6;
}
</style>
